export enum YES_NO_CHOICE {
	UNKNOWN = 0,
	YES = 1,
	NO = 2,
}
